import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import apiClient from '../api/client';
import { Play, Flag } from 'lucide-react';
import { agentStatusMeta } from '../utils/agentStatus';

interface Agent {
  id: string;
  name: string;
  description?: string;
  status: string;
}

export default function TestingCenter() {
  const [agents, setAgents] = useState<Agent[]>([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    apiClient
      .get('/agents')
      .then((res) => setAgents(res.data))
      .catch((e) => console.error('Failed to load agents:', e))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="loading">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <div className="container">
      <h1>测试验证</h1>
      <p className="text-muted mb-4">选择 Agent 进入 Testing Chat 进行验证</p>

      {agents.length === 0 ? (
        <div className="empty">
          <h3>暂无 Agent</h3>
          <button className="primary mt-2" onClick={() => navigate('/agents/create')}>
            新建 Agent
          </button>
        </div>
      ) : (
        <div className="list">
          {agents.map((agent) => {
            const statusMeta = agentStatusMeta(agent.status);
            return (
              <div key={agent.id} className="list-item">
                <div className="list-item-content">
                  <div className="flex items-center gap-2">
                    <h3 style={{ margin: 0 }}>{agent.name}</h3>
                    {statusMeta ? (
                      <span className={`badge ${statusMeta.badgeClass}`}>{statusMeta.label}</span>
                    ) : (
                      <span className={`badge ${agent.status === 'active' ? 'success' : 'info'}`}>{agent.status}</span>
                    )}
                  </div>
                <p className="text-muted text-sm" style={{ margin: '4px 0 0' }}>
                  {agent.description || '暂无描述'}
                </p>
              </div>
              <div style={{ display: 'flex', gap: 8 }}>
                <button
                  className="primary"
                  style={{ padding: '6px 12px' }}
                  onClick={() => navigate(`/agents/${agent.id}/testing`)}
                >
                  <Play size={14} /> 开始测试
                </button>
                <button style={{ padding: '6px 12px' }} onClick={() => navigate(`/agents/${agent.id}/goals`)}>
                  <Flag size={14} /> 目标驱动验证
                </button>
              </div>
            </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
